"use client";

import Link from "next/link";
import Image from "next/image";
import { FaBars, FaTimes, FaChevronDown } from "react-icons/fa";
import UserLoginSheet from "../UserLogin/UserLoginSheet";
import SearchCapsule from "../searchCapsule/SearchCapsule";

export default function MobileNav({
  isMenuOpen,
  setIsMenuOpen,
  navLinks,
  activeDropdown,
  toggleDropdown,
  setActiveDropdown,
  searchQuery,
  setSearchQuery,
  searchResults,
  handleSearchLinkClick,
  searchContainerRef,
  isScrolled,
  isWhiteNavbar,
}) {
  const textColor = isWhiteNavbar ? 'text-gray-900' : 'text-white';
  const hoverColor = isWhiteNavbar ? 'hover:text-gray-500' : 'hover:text-gray-300';
  const iconFilter = isWhiteNavbar ? 'brightness-0 pointer-events-none' : 'brightness-0 invert pointer-events-none';
  const logoFilter = isWhiteNavbar ? 'brightness-0' : 'brightness-0 invert';

  return (
    <>
      <div className="flex navMD:hidden items-center justify-between h-14 w-full px-4 relative z-50">

        {/* Right side (RTL start, visual Right): Doorbell & Login */}
        <div className="flex-1 flex items-center justify-start gap-1 sm:gap-2">
          <button aria-label="اعلانات" className={`flex items-center justify-center w-10 h-10 transition-colors ${hoverColor}`}>
            <Image
              src="/dorbellAlert.svg"
              alt="Alerts"
              width={16}
              height={20}
              className={iconFilter}
            />
          </button>
          <UserLoginSheet align="right" textColor={textColor} width={18} height={16} />
        </div>

        {/* Center: Logo */}
        <div className="flex-shrink-0 flex justify-center">
          <Link href="/" className="flex items-center" aria-label="صفحه اصلی">
            <Image
              src="/barsavoshRing.png"
              alt="Barsavosh Logo"
              width={40}
              height={40}
              priority
              className={`transition-all duration-500 hover:scale-105 ${logoFilter}`}
            />
          </Link>
        </div>

        {/* Left side (RTL end, visual Left): Menu */}
        <div className="flex-1 flex justify-end items-center">
          <button
            onClick={() => setIsMenuOpen(true)}
            className={`${textColor} ${hoverColor} transition-colors p-2`}
            aria-label="باز کردن منوی موبایل"
          >
            <Image
              src="/hamburgerMenu.svg"
              alt="Menu"
              width={16}
              height={13}
              className={iconFilter}
            />
          </button>
        </div>
      </div>

    </>
  );
}